/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftCancelMutationRequest, PostApiBarberShiftCancelMutationResponse, PostApiBarberShiftCancel400, PostApiBarberShiftCancel401, PostApiBarberShiftCancel403, PostApiBarberShiftCancel404, PostApiBarberShiftCancel500 } from "../entities/PostApiBarberShiftCancel";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftCancel } from "../api/postApiBarberShiftCancel";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftCancelMutationKey = () => [{ url: '/api/barber/shift/cancel' }] as const

export type PostApiBarberShiftCancelMutationKey = ReturnType<typeof postApiBarberShiftCancelMutationKey>

export function postApiBarberShiftCancelMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBarberShiftCancelMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftCancelMutationKey()
        return mutationOptions<PostApiBarberShiftCancelMutationResponse, ResponseErrorConfig<PostApiBarberShiftCancel400 | PostApiBarberShiftCancel401 | PostApiBarberShiftCancel403 | PostApiBarberShiftCancel404 | PostApiBarberShiftCancel500>, {data: PostApiBarberShiftCancelMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postApiBarberShiftCancel(data, config)
          },
        })

}

/**
 * @description Мастер отменяет активную или запланированную бронь кресла
 * @summary Отменить бронь смены
 * {@link /api/barber/shift/cancel}
 */
export function usePostApiBarberShiftCancel<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftCancelMutationResponse, ResponseErrorConfig<PostApiBarberShiftCancel400 | PostApiBarberShiftCancel401 | PostApiBarberShiftCancel403 | PostApiBarberShiftCancel404 | PostApiBarberShiftCancel500>, {data: PostApiBarberShiftCancelMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBarberShiftCancelMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftCancelMutationKey()

          const baseOptions = postApiBarberShiftCancelMutationOptions(config) as UseMutationOptions<PostApiBarberShiftCancelMutationResponse, ResponseErrorConfig<PostApiBarberShiftCancel400 | PostApiBarberShiftCancel401 | PostApiBarberShiftCancel403 | PostApiBarberShiftCancel404 | PostApiBarberShiftCancel500>, {data: PostApiBarberShiftCancelMutationRequest}, TContext>
          

          return useMutation<PostApiBarberShiftCancelMutationResponse, ResponseErrorConfig<PostApiBarberShiftCancel400 | PostApiBarberShiftCancel401 | PostApiBarberShiftCancel403 | PostApiBarberShiftCancel404 | PostApiBarberShiftCancel500>, {data: PostApiBarberShiftCancelMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftCancelMutationResponse, ResponseErrorConfig<PostApiBarberShiftCancel400 | PostApiBarberShiftCancel401 | PostApiBarberShiftCancel403 | PostApiBarberShiftCancel404 | PostApiBarberShiftCancel500>, {data: PostApiBarberShiftCancelMutationRequest}, TContext>
      
}